export enum EStorageUrls {
  STORAGE = 'storage',
  FILES = 'files',
}
